import { useTranslation } from 'module/hooks/use-translation';
import { Popconfirm as AntPopconfirm } from 'antd';
import { PopconfirmProps } from 'antd/es/popconfirm';
import { TooltipPlacement } from 'antd/lib/tooltip';
import merge from 'lodash/merge';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';

export interface OzonePopconfirmProps
  extends Omit<PopconfirmProps, 'title' | 'placement'> {
  title?: string | ReactNode;
  subTitle?: string | ReactNode;
  danger?: boolean;
  placement?: TooltipPlacement;
  ctaButtonText?: string;
}

const StyledPopconfirmTitle = styled.div`
  font-weight: var(--heading-7-weight);
  padding-bottom: var(--spacing-03);
`;

export const Popconfirm: FC<React.PropsWithChildren<OzonePopconfirmProps>> = ({
  danger = true,
  title,
  subTitle,
  okButtonProps,
  cancelButtonProps,
  placement = 'top',
  ctaButtonText = '',
  ...rest
}) => {
  const dangerText = useTranslation('delete');
  const confirmText = useTranslation('confirm');
  const deleteConfirmationText = useTranslation('delete_confirmation_message');
  const okText = ctaButtonText || (danger ? dangerText : confirmText);
  const okType = danger ? 'danger' : 'primary';

  const defaultOkButtonProps = {
    type: 'primary',
    style: {
      ...okButtonProps?.style,
      boxShadow: `var(--shadow-highlight) ${
        danger ? 'rgba(var(--red-60-in-rgb)' : 'rgba(var(--brand-color-in-rgb)'
      }, var(--shadow-highlight-color-opacity))`,
    },
  };
  const defaultCancelButtonProps = { type: 'text' };

  const titleText = title || dangerText;
  const subTitleText = subTitle || deleteConfirmationText;

  const titleBoxComponent = (
    <>
      <StyledPopconfirmTitle>{titleText}</StyledPopconfirmTitle>
      <div>{subTitleText}</div>
    </>
  );

  return (
    <AntPopconfirm
      {...rest}
      icon=""
      okType={okType}
      title={titleBoxComponent}
      okText={okText}
      placement={placement}
      okButtonProps={merge(okButtonProps, defaultOkButtonProps)}
      cancelButtonProps={merge(cancelButtonProps, defaultCancelButtonProps)}
    />
  );
};
